import logo from './logo.svg';
import './App.css';
import Login from './Login';
import Logout from './Logout';
function App() {
  return (
    <div className="App">
     <h1>hii</h1>
     <Login/>
     <Logout/>
    </div>
  );
}

export default App;
